/* esm.sh - applesauce-common@5.2.0/dist/helpers/reaction */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/reaction.mjs";
